import React from "react";
import styled from "styled-components";

import { Button } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";
import { defaultTitle, smallText } from "js/textStyles";

interface UpgradeSectionProps {
    className?: string;
    title?: string;
    body?: string;
    buttonText: string;
    buttonIcon: string | React.ReactNode;
    buttonOnClick: () => void;
    darkMode?: boolean;
}

const StyledUpgradeSection = styled.div<{ $darkMode?: boolean }>`
    margin-top: auto;
    display: flex;
    padding: 10px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
    border-radius: 3px;
    background: ${props => props.$darkMode ? "#4B4E55" : "#FFF"};
`;

export const UpgradeTextHeader = styled.div<{ $darkMode?: boolean }>`
    ${defaultTitle}
    color: ${props => props.$darkMode ? "#FFF" : "#333"};
    letter-spacing: 0;
`;

export const UpgradeTextBody = styled.div<{ $darkMode?: boolean }>`
    ${smallText}
    color: ${props => props.$darkMode ? themeColors.lightGray : themeColors.mediumGray};
    margin-bottom: 10px;
`;

const UpgradeSection = ({ className, title, body, buttonText, buttonIcon, buttonOnClick, darkMode = false }: UpgradeSectionProps) => {
    return (<StyledUpgradeSection $darkMode={darkMode} className={className}>
        {title && (
            <UpgradeTextHeader $darkMode={darkMode}>
                {title}
            </UpgradeTextHeader>
        )}
        {body && (
            <UpgradeTextBody $darkMode={darkMode}>
                {body}
            </UpgradeTextBody>
        )}
        <Button
            upgrade
            width="100%"
            onClick={buttonOnClick}
        >
            {typeof buttonIcon === "string" ? <img src={buttonIcon} /> : buttonIcon}
            {buttonText}
        </Button>
    </StyledUpgradeSection>);
};

export default UpgradeSection;
